import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PlainButton from "../../../../../components/buttons/PlainButton";
import { CgClose } from "react-icons/cg";
import { phoneRegExp } from "../../../../../data/Constants";
import { atpUsersService } from "../../../../../services/atpUsersService";
import { toast } from "react-toastify";

// Validation Schema using Yup
const validationSchema = Yup.object().shape({
    name: Yup.string().max(80, "Name must be at most 80 characters").required("Name is required"),

    company_name: Yup.string().max(100, "Organization Name must be at most 100 characters").required("Organization Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required").matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email address"),
    // phoneNumber: Yup.string() // Use phoneNumber to match the form field name
    //     .matches(phoneRegExp, "Telephone is not valid")
    //     .required("Telephone is required"),
    // password: Yup.string()
    //     .matches(/^(?!\s)/, "Password cannot start with space")
    //     .min(8, "Password must be at least 8 characters")
    //     .matches(/[0-9]/, "Password requires a number")
    //     .matches(/[a-z]/, "Password requires a lowercase letter")
    //     .matches(/[A-Z]/, "Password requires an uppercase letter")
    //     .matches(/[\W_]/, "Password requires a symbol")
    //     .matches(/(?<!\s)$/, "Password cannot end with space")
    //     .required("Password is required"),
});

const ATPForm = ({ handleClose, handleSubmit }) => {
    const [initialValues, setInitialValues] = useState({
        name: "",
        company_name: "",
        email: "",
        // phoneNumber: "", // Match this with Yup validation schema
        // password: "",
    });

    return (
        <>
            <div className="Confirm_popup">
                <div className="modal custom-popup-overlay">
                    <div className="modal-content custom-popup-add" style={{ width: "878px" }}>
                        <div className="d-flex justify-content-between align-items-center">
                            {" "}
                            <h2>Add ATP User</h2>
                            <div
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent event propagation to parent
                                    handleClose(); // Close the modal
                                }}
                                className="d-flex justify-content-end croseicn"
                            >
                                <CgClose
                                    style={{
                                        color: "#D1D5DB",
                                        height: "30px",
                                        width: "30px",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="after-line-tittle"></div>

                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            enableReinitialize={true}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values); // Stop form submission
                                handleClose();
                            }}
                        >
                            {({ isSubmitting }) => (
                                <Form className="stepper-form-container">
                                    <div className="row mb-5">
                                        <div className="col-lg-6 col-12">
                                            <label className="mb-1">Pic Name</label>
                                            <Field type="text" name="name" className="form-control mb-2" autoComplete="off" placeholder="Pic Name" />
                                            <ErrorMessage name="name" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                        </div>
                                        <div className="col-lg-6 col-12">
                                            <label className="mb-1">Company Name</label>
                                            <Field type="text" name="company_name" className="form-control mb-2" autoComplete="off" placeholder="Company Name" />
                                            <ErrorMessage name="company_name" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                        </div>
                                    </div>

                                    <div className="row mb-5">
                                        <div className="col-lg-6 col-12">
                                            <label className="mb-1">Email</label>
                                            <Field type="email" name="email" className="form-control mb-2" autoComplete="off" placeholder="Email" />
                                            <ErrorMessage name="email" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                        </div>
                                        {/* <div className="col-lg-6 col-12">
                                            <label className="mb-1">Telephone Number</label>
                                            <Field
                                                type="text"
                                                name="phoneNumber" // Match with the Yup schema
                                                className="form-control mb-2"
                                                autoComplete="off"
                                                placeholder="Telephone Number"
                                            />
                                            <ErrorMessage
                                                name="phoneNumber"
                                                component="div"
                                                className="text-danger fs-14 fw-400 mt-1"
                                            />
                                        </div> */}
                                    </div>

                                    {/* <div className="row mb-5">
                                        <div className="col-lg-6 col-12">
                                            <label className="mb-1">Password</label>
                                            <Field
                                                type="password"
                                                name="password"
                                                className="form-control mb-2"
                                                autoComplete="off"
                                                placeholder="Set Password"
                                            />
                                            <ErrorMessage
                                                name="password"
                                                component="div"
                                                className="text-danger fs-14 fw-400 mt-1"
                                            />
                                        </div>
                                    </div> */}

                                    <div className="border-before pt-4"></div>
                                    <div className="right-content d-flex gap-3 justify-content-end pt-5 btn_css">
                                        <button
                                            type="button"
                                            className="text-gray-150 fw-500 fs-15 cursor-pointer back_button"
                                            style={{
                                                backgroundColor: "#d3d3d3",
                                                height: "47px",
                                                borderRadius: "6px",
                                                width: "90px",
                                                color: "#29348f",
                                            }}
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </button>
                                        <PlainButton type="submit" isLoading={isSubmitting}>
                                            Submit
                                        </PlainButton>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ATPForm;
